import React from 'react'
import className from 'classnames/bind'

import MyhouseMainHouseRegistGuide from '@Components/atoms/MyhouseMainHouseRegistGuide'
import MyhouseMainHeader from '@Components/atoms/MyhouseMainHeader'
import Footer from '@Components/common/Footer'

const MyhouseMainHouseRegistGuidePage: React.FC = () => {
  return (
    <>
      <MyhouseMainHeader alarm={false} setting={false} currentHouseNo={0} />
      <MyhouseMainHouseRegistGuide />
      <Footer />
    </>
  )
}

export default MyhouseMainHouseRegistGuidePage
